import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useState } from "react";
import FeaturesListElement from "./FeaturesListElement";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
  },
}));

const FeaturesList = (props) => {
  const classes = useStyles();
  const [featureVotes, setFeatureVotes] = useState({});
  const [featureMessages, setFeatureMessages] = useState({});

  useEffect(() => {
    // Get all feature IDs
    const featureIds = props.features.map((feature) => feature[".key"]);

    // Create a single query to get all votes and messages for all features
    const db = window.firebase.firestore();

    // Create maps to store counts
    const voteCounts = {};
    const messageCounts = {};
    featureIds.forEach((id) => {
      voteCounts[id] = 0;
      messageCounts[id] = 0;
    });

    // Create promises for votes queries
    const votePromises = featureIds.map((featureId) =>
      db
        .collection("features")
        .doc(featureId)
        .collection("votes")
        .where("type", "==", "1")
        .get()
    );

    // Create promises for messages queries
    const messagePromises = featureIds.map((featureId) =>
      db.collection("features").doc(featureId).collection("messages").get()
    );

    // Execute all queries in parallel
    Promise.all([Promise.all(votePromises), Promise.all(messagePromises)])
      .then(([voteSnapshots, messageSnapshots]) => {
        // Process votes
        voteSnapshots.forEach((querySnapshot, index) => {
          const featureId = featureIds[index];
          voteCounts[featureId] = querySnapshot.size;
        });
        setFeatureVotes(voteCounts);

        // Process messages
        messageSnapshots.forEach((querySnapshot, index) => {
          const featureId = featureIds[index];
          messageCounts[featureId] = querySnapshot.size;
        });
        setFeatureMessages(messageCounts);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [props.features]);

  // Sort features based on votes if needed
  const sortedFeatures = [...props.features].sort((a, b) => {
    if (props.sortBy === "most_votes") {
      return (featureVotes[b[".key"]] || 0) - (featureVotes[a[".key"]] || 0);
    }
    return 0;
  });

  return (
    <div className={classes.root}>
      {sortedFeatures.map((feature) => (
        <FeaturesListElement
          key={feature[".key"]}
          feature={feature}
          handleFeatureClick={props.handleFeatureClick}
          numVotes={featureVotes[feature[".key"]] || 0}
          numMessages={featureMessages[feature[".key"]] || 0}
        />
      ))}
    </div>
  );
};

export default FeaturesList;
